import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { AuthContext } from "../Auth/AuthDataProvider.jsx";
import Footer from "../../views/Footer/Footer.jsx"
import apiUtil from '../../api/apiUtil.jsx';

import { 
  Collapse,
  Divider,
  Button,
  Menu,
  MenuItem,
  Box,
  List,
  ListItem,
} from '@material-ui/core';

// import Icon from '@material-ui/core/Icon';
import logoTextWhite from '../../assets/img/logo_text_white.png';

import { ReactComponent as ArrowRightIcon } from '../../assets/img/left_menu/arrow-right.svg';
import { ReactComponent as ArrowDownIcon } from '../../assets/img/left_menu/arrow-down.svg';
import { ReactComponent as DashboardIcon } from '../../assets/img/left_menu/dashboard.svg';
import defaultImg from '../../assets/img/default_image.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpFromBracket, faDownload, faFileLines, faGear, faMessage, faChartColumn, faFileCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import {RoleAccessService} from '../../data/role-access'; 
const CustomMenuItem = (props) => {
  let {text, icon, url, active, items, onDrawerToggle} = props;
  let [open, setOpen] = React.useState(active);

  return <React.Fragment>
    <ListItem
      // onClick = {() => onDrawerToggle? onDrawerToggle(): ""}
      className={'custom-item ' + ((typeof active === "function") ? active() : (active ? "active" : ""))}
    >
      <Link to={(items && items.length > 0) ? "" : url}
        onClick={(e) => {
          // e.stopPropagation();

          if(items && items.length > 0){
            e.preventDefault();
            setOpen(!open);
            
            if(onDrawerToggle){
              onDrawerToggle()
            }
          }
        }}
        className="d-flex flex-column text-center"
      >
        {icon ? <div className="icon-style">{icon}</div> : <span className={'no-icon'}></span>}
        <div className="nav-text">{text}</div>
        {(items && items.length > 0) && (open ? <ArrowDownIcon className={'custom-expand-down'} /> : <ArrowRightIcon className={'custom-expand-right'} />)}
      </Link>
    </ListItem>
    {(items && items.length > 0) && <Collapse in={open} timeout="auto" unmountOnExit>
      <List className={'sub-nav'} component="div" disablePadding>
        {items.map((item, i) => {
          return <React.Fragment key={i}>
            {item}
          </React.Fragment>;
        })}
      </List>
    </Collapse>}
  </React.Fragment>
}


class LeftMenu extends Component {
  static contextType = AuthContext;
  
  constructor(props){
    super(props);

    this.state = {
      profileMenu: null
    };
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.profileMenu !== this.state.profileMenu) {
        this.setState({
            profileMenu: nextProps.profileMenu
        });
    }
  }
  
  validURL = (str) => {
    let pattern = new RegExp('^(https?:\\/\\/)?'+
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
      '((\\d{1,3}\\.){3}\\d{1,3}))'+
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
      '(\\?[;&a-z\\d%_.~+=-]*)?'+
      '(\\#[-a-z\\d_]*)?$','i');
    return !!pattern.test(str);
  }

  handleServiceChange = (e) => {
    let url = e.target.value;
    if (!this.validURL(url)) return false;
    window.location.replace(url);
  } 
  
  getUserinfo = () => {
    const { user } = this.context;
    let userInfo = apiUtil.getObject(user);
    return (userInfo && userInfo.owner_info) ? userInfo.owner_info : null;
  }

  getUserLogo = () => {
    const { user } = this.context;
    return apiUtil.getUserLogo(user, defaultImg);
  }
  getUserName = () => {
    const { user } = this.context;
    return apiUtil.getUserName(user, defaultImg);
  }
  getUserEmail = () => {
    let userInfo = this.getUserinfo();

    return (userInfo && userInfo.email) ? userInfo.email : '';
  }

  getCompanyID = () => {
    let company = window.localStorage.getItem('company_id');
    return company ? window.btoa( company ) : ''; //decript  window.atob( company )
  }
  
  logout = ()  => {
    const { clearStorage } = this.context;

    this.setState({
      profileMenu: null,
    });

    clearStorage();

    // window.location.reload();
    window.location = "/";
  }

  // get the the item list of resource for new role
  getResourceItemListForNewRole = (currentRole) => {
    let grantedMenu = new RoleAccessService();

    // 'Transport operator', 'Logistic assistance', 'Vehicle'
    let item_list = [] ;
    if( ! grantedMenu.admin_roles.includes(currentRole)) {
      if (grantedMenu.getUniqueRolePermission().includes('transport_operator')) {
          item_list.push(<CustomMenuItem
            onDrawerToggle={this.props.onDrawerToggle} 
            text={'Driver'}
            url={'/resources/transport-operator'}
            active={(this.props.location.pathname === "/resources/transport-operator" ? true : false)}
          />,
          <CustomMenuItem
            onDrawerToggle={this.props.onDrawerToggle} 
            text={'Driver Assistant'}
            url={'/resources/logistic-assistance'}
            active={(this.props.location.pathname === "/resources/logistic-assistance" ? true : false)}
          /> );
      }
      if (grantedMenu.getUniqueRolePermission().includes('resources_vehicle')) {
        item_list.push( <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle}   
          text={'Vehicle'}
          url={'/resources/vehicle'}
          active={(this.props.location.pathname === "/resources/vehicle" ? true : false)}
        /> );
      }
      return item_list;
    }
    return item_list = [
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle} 
        text={'Driver'}
        url={'/resources/transport-operator'}
        active={(this.props.location.pathname === "/resources/transport-operator" ? true : false)}
      />,
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle} 
        text={'Driver Assistant'}
        url={'/resources/logistic-assistance'}
        active={(this.props.location.pathname === "/resources/logistic-assistance" ? true : false)}
      />,
      <CustomMenuItem
        onDrawerToggle={this.props.onDrawerToggle}   
        text={'Vehicle'}
        url={'/resources/vehicle'}
        active={(this.props.location.pathname === "/resources/vehicle" ? true : false)}
      />,
    ]
  }

  render() {
    const { isCustomerRequired, currentRole, appPermission } = this.context;
    let grantedMenu = new RoleAccessService();
    return <Box>
      <div style={{minHeight:"87vh", marginTop:'76px'}} className="d-flex flex-column justify-content-between"><List component="nav" className="customer-nav-style">
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Dashboard'}
          icon={<DashboardIcon />}
          url={'/customer-dashboard'}
          active={(this.props.location.pathname === "/customer-dashboard" || this.props.location.pathname == "/job-schedule-lists" || this.props.location.pathname == "/order-summary" || this.props.location.pathname == "/order-summary-list" || this.props.location.pathname.includes("/customer-recycle-bin") ? true : false)}
        />
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Custom quotation'}
          icon={<FontAwesomeIcon icon={faFileCircleQuestion} />}
          url={'/request-form'}
          active={(this.props.location.pathname === "/request-form" ? true : false)}
        />
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'My Orders'}
          icon={<FontAwesomeIcon icon={faArrowUpFromBracket} />}
          url={'/new-order'}
          active={(this.props.location.pathname === "/new-order" || this.props.location.pathname === "/order-schedule" || this.props.location.pathname === "/new-order-form" || this.props.location.pathname.includes("/my-order-recycle-bin") ? true : false)}
        />
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Analytics'}
          icon={<FontAwesomeIcon icon={faChartColumn} />}
          url={'/analytics/client-overview'}
          active={(this.props.location.pathname.includes("/analytics") || this.props.location.pathname.includes("/job-schedule-list")? true : false)}
        />
        <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Invoices'}
          icon={<FontAwesomeIcon icon={faFileLines} />}
          url={'/invoice'}
          active={(this.props.location.pathname === "/invoice"? true : false)}
        />
      </List>
      <Button 
          aria-label="profile-menu" 
          aria-haspopup="true"
          className="profile-menu-btn"
          onClick={(event) => {
            if(this.state.profileMenu != null) {
              this.setState({
                profileMenu: null
            });
            } else {
              this.setState({
                  profileMenu: event.currentTarget
              });
            }
          }}
      >
          <img className="profile-pic-logo" src={this.getUserLogo()} alt="User" width="35" height="35" />
          {/* <span className="ps-2 user-info-name">{this.getUserName()}</span> */}
          {/* <ArrowDownIcon /> */}
      </Button>
      <Menu
          id="profile-menu-customer"
          classname="text-center"
          anchorEl={this.state.profileMenu}
          keepMounted
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          open={Boolean(this.state.profileMenu)}
          onClose={() => {
              this.setState({
                  profileMenu: null
              });
          }}
      >   
          <div className="user-info">
            <img src={this.getUserLogo()} alt="User" 
              className="profile-pic-logo"
              width="35" height="35"/>
            <div className="user-info-right" style={{paddingLeft: '40px', paddingRight: '40px'}}>
              <div className="user-info-name">{this.getUserName()}</div>
              <div className="user-info-email">{this.getUserEmail()}</div>
            </div>
            
          </div>
          <Divider className="user-info-divider"/>
          {/* <div className="user-info-2">
               <div className="user-info-name">Organization ID</div>
            <div className="user-info-right">
              <div className="user-info-email">{this.getCompanyID()}</div>
            </div>
            
          </div>
          <Divider className="user-info-divider"/> */}
          <a 
          style={{textAlign:'center', padding: '8px', textDecoration:'none', cursor: 'default'}}
              onClick={() => {
                this.logout();
              }}
          >
              <div className="text-center">Sign Out</div>
          </a>
      </Menu>
      <List component="nav" className="customer-nav-style" style={{paddingTop: 0}}>
         <CustomMenuItem
          onDrawerToggle={this.props.onDrawerToggle} 
          text={'Help'}
          icon={<FontAwesomeIcon icon={faMessage} />}
          url={'/help-center'}
          active={(this.props.location.pathname === "/help-center"? true : false)}
        />
        </List>
      </div>
    </Box>
  }

  
}

export default withRouter(LeftMenu);
